// Native Web Share + fallback (clipboard copy). Small utilities used across pages.
import { toast } from "sonner";

export async function share({ title, text, url }) {
  const nav = typeof navigator !== "undefined" ? navigator : null;
  if (nav?.share) {
    try {
      await nav.share({ title, text, url });
      return "shared";
    } catch (e) {
      // User cancelled or share failed
      if (e?.name === "AbortError") return "abort";
    }
  }
  // Fallback: copy URL to clipboard
  try {
    await nav?.clipboard?.writeText(url || text);
    return "copied";
  } catch (e) {
    return "failed";
  }
}

export function twitterIntent({ text, url }) {
  const params = new URLSearchParams({ text, url });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function reportShareToast(result, tKey) {
  const t = tKey || ((k) => k);
  if (result === "shared") toast.success(t("share.shared_ok"));
  else if (result === "copied") toast.success(t("share.copied_ok"));
  else if (result === "failed") toast.error(t("share.failed"));
  // silent for abort
}
